import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from './client';
import { QUERY_KEYS } from '@/lib/constants';

export function useSettings() {
  return useQuery({
    queryKey: QUERY_KEYS.settings,
    queryFn: () => api.get<{ data: Record<string, string> }>('/api/v1/settings'),
    select: (res) => res.data,
  });
}

export function useUpdateSettings() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: Record<string, string>) =>
      api.patch('/api/v1/settings', body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: QUERY_KEYS.settings });
      qc.invalidateQueries({ queryKey: QUERY_KEYS.dashboard });
    },
  });
}
